<div class="relative grid grid-cols-1 gap-8 mt-8">

    <div *ngIf="article" class="top-0 w-full row-span-full">
        <div class="flex justify-end">

            <div class="grow">
                <button [routerLink]="['..']"
                    class="text-primary-500 hover:bg-primary-100 text-sm uppercase font-bold px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
                    type="button"><i class="fa fa-chevron-left mr-2 leading-relaxed"></i>
                    Back
                </button>
            </div>

            <div>
                <button (click)="delete()" [disabled]="working"
                    class="bg-red-500 text-white active:bg-red-500 hover:bg-red-300 disabled:bg-primary-200 text-sm uppercase font-bold px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                    type="button"><i class="fa fa-trash-can mr-2 leading-relaxed"></i>
                    Delete
                </button>
                <!-- <button (click)="refreshRecord()" [disabled]="working"
                        class="bg-primary-400 text-white active:bg-primary-500 hover:bg-primary-700 disabled:bg-primary-200 text-sm uppercase font-bold px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none {{article.publishStatus == 'review' ? 'mr-3' : ''}}  ease-linear transition-all duration-150"
                        type="button"><i class="fa fa-refresh mr-2 leading-relaxed"></i>
                        Refresh
                    </button> -->
            </div>
        </div>
    </div>

    <div class="relative flex flex-col break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">

        <form *ngIf="article" [formGroup]="pageForm" (ngSubmit)="update()">
            <div class="rounded-t bg-white mb-0 px-6 py-4">
                <span class="text-blueGray-700 text-lg font-bold">Update Article</span>
            </div>

            <div class="flex flex-wrap px-6 py-4">
                <div class="mb-1 w-full">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Title *
                    </label>
                    <input type="text" type="title" formControlName="title" id="title" name="title" required
                        class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full py-1.5 px-3 ease-linear transition-all duration-150"
                        rows="4" />
                    <div class="{{ pageForm.get('title')?.invalid && (pageForm.get('title')?.dirty || pageForm.get('title')?.touched) ? 'visible' : 'invisible'}}
                        pt-1 h-6 text-red-500 text-xs">
                        <p *ngIf="pageForm.get('title')?.errors?.['required']">
                            Value is required
                        </p>
                        <div
                            *ngIf="pageForm.get('title')?.errors?.['minlength'] || pageForm.get('title')?.errors?.['maxlength']">
                            Min 10 and max 200 characters required
                        </div>
                    </div>
                </div>
                <div class="mb-1 w-full">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Description *
                    </label>
                    <textarea type="text" type="description" formControlName="description" id="description"
                        name="description" required
                        class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        rows="4">
                        </textarea>
                    <div
                        class="{{ pageForm.get('description')?.invalid && (pageForm.get('description')?.dirty || pageForm.get('description')?.touched) ? 'visible' : 'invisible' }} h-6 text-red-500 text-xs">
                        <div *ngIf="pageForm.get('description')?.errors?.['required']">
                            Value is required
                        </div>
                        <div
                            *ngIf="pageForm.get('description')?.errors?.['minlength'] || pageForm.get('description')?.errors?.['maxlength']">
                            Min 10 and max 500 characters required
                        </div>
                    </div>
                </div>
                <div class="mb-1 w-full">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold">
                        Tags
                    </label>
                    <div class="flex flex-wrap gap-1">
                        <button (click)="removeTag(i)" type="button" *ngFor="let item of tags; index as i"
                            data-dismissible="chip"
                            class="relative flex select-none items-center whitespace-nowrap rounded-lg bg-primary-500 py-1.5 px-3 my-1 text-xs font-bold text-white">
                            <span class="grow-0">{{item}}<i class="fa fa-close ml-2 leading-relaxed"></i></span>
                        </button>
                    </div>
                    <div class="flex flex-row align-middle mt-1">
                        <input formControlName="tagField" id="tagField" name="tagField" type="text"
                            class="border-0 grow placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
                        <button (click)="addTag()" type="button"
                            class="bg-primary-500 basis-1/4 whitespace-nowrap rounded ml-4 text-xs text-white px-2">Add
                            Tag</button>
                    </div>
                    <div
                        class="{{pageForm.get('tagField')?.invalid && (pageForm.get('tagField')?.dirty || pageForm.get('tagField')?.touched)? 'visible' : 'invisible' }} pt-1 h-4 text-red-500 text-xs">
                        @if(pageForm.get('tagField')?.errors?.['invalidValue']) {
                        <p>No blanks or spaces allowed</p>
                        } @else if(pageForm.get('tagField')?.errors?.['maxValuesAllowed']) {
                        <p>Only 10 values allowed</p>
                        }
                    </div>
                </div>
                <div class="w-full mb-1">
                    <button type="submit" [disabled]="!pageForm.valid"
                        class="bg-secondary-500 hover:bg-secondary-700 active:bg-primary-500 disabled:bg-primary-200 mt-4 mr-2 text-white font-bold text-sm uppercase rounded px-4 py-2"
                        mat-button>
                        <div *ngIf="!working" class="inline-block">
                            <i class="fa fa-save mr-2 leading-relaxed"></i>Update
                        </div>
                        <div *ngIf="working" class="inline-block">
                            <app-loading-dots></app-loading-dots>
                        </div>
                    </button>
                </div>
            </div>
        </form>

    </div>
</div>